import { useQuery } from 'react-query';
import { getAllReportConfigsForProgram } from '../../../api/reports';
import { ReportConfigDto } from '../../../types/reports';

const getReportsConfig = async (programId: string | undefined) => {
  if (!programId) return null;
  const { data } = await getAllReportConfigsForProgram(programId);
  console.log('allReportConfigs', data);
  const hash = await (data as ReportConfigDto[]).reduce((pre, curr) => {
    return curr.reportConfigId
      ? {
          ...pre,
          [curr.reportConfigId]: curr,
        }
      : pre;
  }, {} as Record<string, ReportConfigDto>);
  return hash;
};

export default function useReportsConfig(programId: string | undefined) {
  return useQuery(['reportsConfig', programId], () =>
    getReportsConfig(programId)
  );
}
